"use strict";
exports.isArray = Array.isArray || (function (x) { return x && typeof x.length === 'number'; });
//# sourceMappingURL=isArray.js.map


// WEBPACK FOOTER //
// ./techpad-upgrade/~/rxjs/util/isArray.js